module.exports = __webpack_public_path__ + "static/media/logo.d37b2ac5.jpg";